module.exports = __webpack_public_path__ + "media/components/country-flag/static/qa-8dfd32266f194cfe89c84d1ba5af4348.svg";